import { createStyles, Title, Text, Container, Group } from '@mantine/core';
import { useEffect, useState } from 'react';
import API from '../apis/api';
import { GetInfoResponse, ToTranslateField } from '../apis/response/GetInfoResponse';
import { GetNavbarCategoriesReponse, TransformToCategoryMenu } from '../apis/response/GetNavbarCategoriesResponse';
import Carousel from '../components/carousel';
import CategoryNavbar, { CategoryMap } from '../components/category-navbar';
import ImageStorageService from '../services/ImageStorageService';
import { TranslateField, GetTranslated } from '../types/translate-field';
import { GetImageResponse, ToImageSource } from '../apis/response/GetImageResponse';
import DefaultContainer from '../components/container';
import { ProductCardProp } from '../components/product-card';
import { CurrentLocale } from '../App';
import { GetPortalResponse, PortalLink, ToPortalLink } from '../apis/response/GetPortalResponse';
import { SharedProps } from '../types/shared-props';

const useStyles = createStyles((theme) => ({
  home: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },

  hero: {
    position: 'relative',
    // backgroundImage:
    //   'url(https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    height: 450,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '12%',

    [theme.fn.smallerThan('sm')]: {
      padding: '15px',
      justifyContent: 'center',
    },
  },

  container: {
    width: 320,
    height: 320,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignSelf: 'center',
    zIndex: 1,
    position: 'relative',
    backgroundColor: theme.colors.offWhite[0],
    opacity: 50,
    padding: 30,
    margin: 0,
  },

  title: {
    color: theme.colors.hkc[1],
    fontSize: 30,
    fontWeight: 900,
    lineHeight: 1.1,
    textAlign: 'left',
    fontFamily: theme.other.englishFont.BerlinSans
  },

  description: {
    color: theme.colors.hkc[2],
    textAlign: 'left',
    fontSize: 16,
  },

  slash: {
    height: theme.other.layout.slashHeight,
    backgroundColor: theme.colors.hkc[0],
    width: '80%',
    marginTop: 10,
  },

  content: {
    // padding: '15px 0px',
  },
}));


interface HomePageProps {
  imgBinaryList?: ProductCardProp[]
  hero?: TranslateField
  cover?: string
}

const Home = () => {
  const { classes } = useStyles()
  const init: HomePageProps & SharedProps = {}
  const [props, setProps] = useState(init)

  const fetchData = async () => {
    const imageService = new ImageStorageService()
    const imgBinaryList = (await imageService.GetRandomCardProps())
    const family: GetInfoResponse = (await API.Info.GetInfo('hl_family')).obj[0]
    const hero = (ToTranslateField(family))
    const res: GetImageResponse = (await API.ImageStorage.GetHomepageCover()).obj
    const random = Math.round(Math.random() * (res.items.length - 1))
    const cover = (ToImageSource(res.items[random]))
    
    const c: GetNavbarCategoriesReponse = (await API.Category.GetNavbarCategories()).obj

    const categories = TransformToCategoryMenu(c.items)
    const usefulRes: GetPortalResponse = (await API.Info.GetUsefulLinks()).obj
    const useful = usefulRes.items.map(x => ToPortalLink(x))
    console.log(categories);
    const newProps = {
      imgBinaryList, hero, cover, categories, useful
    }
    
    setProps(newProps)
  }
  useEffect(() => {
    fetchData()
    
  }, [])

  return (
    <div className={classes.home}>
      <DefaultContainer>
        <div className={classes.hero} style={{ backgroundImage: `url(${props.cover})` }}>
          <Container className={classes.container}>
            <Title className={classes.title}>Hobby Lobby® Family</Title>
            <Group >

              <Text className={classes.description} size="xl" mt="xl" dangerouslySetInnerHTML={{__html:props.hero ? GetTranslated(props.hero, CurrentLocale) : ''}}>
              </Text>
              <div className={classes.slash}></div>
            </Group>
          </Container>
        </div>
        <div className={classes.content}>
          {
            props.categories && props.useful ?
              <CategoryNavbar data={props.categories} useful={props.useful} short/>
              : <></>
          }
          {
            props.imgBinaryList ?
              <Carousel photos={props.imgBinaryList} />
              : <></>
          }
        </div>
      </DefaultContainer>
    </div>
  )
}

export default Home

